import React from 'react';
import classNames from 'classnames';
import { Toggle } from 'ncoded-component-library';
import CheckIcon from 'icons/Check.icon';
import { ToggleProps } from 'ncoded-component-library/build/components/molecules/Toggle/Toggle.component';

import './CheckToggle.styles.scss';

type CheckToggleProps = {
  className?: string;
} & ToggleProps;

const CheckToggle: React.FC<CheckToggleProps> = (props) => {
  const { className, ...rest } = props;

  const classes = classNames('check-toggle', className);

  return (
    <Toggle
      className={classes}
      onContent={
        <p className="circle">
          <CheckIcon />
        </p>
      }
      offContent={<p className="circle" />}
      {...rest}
    />
  );
};

export default CheckToggle;
